<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Wykres - Wartość faktur</h1>

    <line-chart :chart-data="chartData" :options="chartOptions" :height="100"></line-chart>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LineChart from '@/ShtaxComponents/LineChart'

export default {
  metaInfo: { title: 'Wartość faktur' },
  components: {
    LineChart
  },
  layout: Layout,
  props: {
    stats: Object
  },
  remember: 'form',
  data() {
    return {
      chartData: {
        labels: this.stats.labels,
          datasets: [
            {
              label: 'Wartość netto ogółem',
              borderColor: '#E31E24',
              fill: false,
              data: this.stats.value,
              labels: this.stats.labels,
              yAxisID: 'y-axis-1',
              lineTension: 0
            }
          ]
      },
      chartOptions: {
        tooltips: {
          callbacks: {
            title: function(tooltipItem, data) {
              var dataset = data.datasets[tooltipItem[0].datasetIndex];
              var index = tooltipItem[0].index;
              return dataset.labels[index];
            }
          }
        },
        scales: {
          yAxes: [{
            type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
            display: true,
            position: 'left',
            id: 'y-axis-1',
          }],
        }
      }
    }
  },
  methods: {
  },

  computed: {
  },

  watch: {
  },

  mounted() {
  }
}
</script>